module.exports = __webpack_public_path__ + "img/erweima.a23842a2.png";